import React from 'react';
import mixpanel from 'mixpanel-browser';

import { platformSectionObj } from '../../constants/Pages/Landing';

import './PlatformSection.css';

export const PlatformSection = ({ userId }) => {
  const { title, platformContentBoxes } = platformSectionObj;

  return (
    <div className="platform-section-wrapper">
      <h2 className="platform-section-header">{title}</h2>
      <div className="platform-wrapper-box">
        {Object.keys(platformContentBoxes).map((contentHeader) => (
          <div
            className="platform-box-content"
            key={contentHeader}
            onClick={() => {
              mixpanel.track('Our Platform', {
                distinct_id: userId,
                sectionContent: contentHeader,
              });
            }}
          >
            {platformContentBoxes[contentHeader].icon()}
            <h4 className="platform-content-header"> {contentHeader} </h4>
            <div className="platform-content-description">
              {platformContentBoxes[contentHeader].description}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
